/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  Button,
  Tag,
  Typography,
  Select,
  Modal,
  Row,
  Col,
  Image,
} from "antd";
import OtpInput from "react-otp-input";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { DEFAULT_PROFILE_IMAGE } from "../../../common/awsBucket";
import UserFormModal from "./components/UserFormModal";
import ActionsColumn from "./components/ActionsColumn";
import AdvancedSearchForm from "../../../common/SearchForm";
import styles from "../../../common/Layout.module.scss";
import permissions from "../../../common/variables/labPermission";
import { formatPayload } from "../../../common/PhoneInput";
import UserDescriptionModal from "./components/UserDescriptionModal";

const { Title, Link } = Typography;
const { Option } = Select;

function UserManagement(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const [activateModalVisible, setActivateModalVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [currentColumn, setCurrentColumn] = useState({});
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [searchOption, setSearchOption] = useState(false);

  const toggleActivateModalVisibility = (id) => {
    setSelectedColumn(id);
    setActivateModalVisible(!activateModalVisible);
    setOtp("");
  };

  const showModal = () => {
    setModalVisible(true);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const onAddUser = async (payload) => {
    const payloadObj = { user: formatPayload(payload) };
    await props.addLabCompanyStaff(payloadObj);
    setTimeout(() => {
      hideModal();
      props.getAllLabCompanyStaff();
    }, 1000);
    await props.getAllLabCompanyStaff();
  };

  const onUpdateUser = async (payloadObj) => {
    await props.updateLabCompanyStaff(payloadObj);
    await props.getAllLabCompanyStaff();
  };

  const onEditPermissions = async (payloadObj) => {
    await props.updateLabCompanyStaffPermission(payloadObj);
    await props.getAllLabCompanyStaff();
  };

  const activateUser = async () => {
    await props.activateLabCompanyStaff({
      id: selectedColumn,
      otp_digest: otp,
    });
    await props.getAllLabCompanyStaff();
    toggleActivateModalVisibility();
  };

  const onOtpChange = (value) => {
    setOtp(value);
  };

  const renderData = useCallback(() => {
    props.getAllLabCompanyStaff.call();
    props.getAllLabBranchLists.call();
    props.getAllCountryCodes.call();
  }, [
    props.getAllLabCompanyStaff,
    props.getAllLabBranchLists,
    props.labCompanyStaffUpdated,
    props.getAllCountryCodes,
  ]);

  useEffect(() => {
    renderData();
  }, [renderData]);

  const userDescriptionAction = async (columnData) => {
    await props.getSingleLabCompanyStaff.call(null, `id=${columnData.id}`);
    setDescriptionModal(true);
    setCurrentColumn(columnData);
  };

  const columns = [
    {
      title: "STAFF NAME",
      key: "pic_url",
      width: "35%",
      dataIndex: "pic_url",
      render: (_, columnData) => (
        <Row className="name-details-row">
          <Col span={4} className="table-fc-image">
            <Image
              src={
                columnData.pic_url ? columnData.pic_url : DEFAULT_PROFILE_IMAGE
              }
              preview={false}
            />
          </Col>
          <Col span={14} offset={1}>
            <div className="table-fc-name">{columnData.name}</div>
            <div className="table-fc-email">
              {columnData.phone_code}
              {columnData.phone}
            </div>
            <div className="table-fc-email">{columnData.email}</div>
            <div className="table-fc-status">
              {columnData.status ? (
                <span className="activate">Active</span>
              ) : (
                <span className="inActivateNotverified">Blocked</span>
              )}
            </div>
            <div className="view-details">
              <Link onClick={() => userDescriptionAction(columnData)}>
                VIEW DETAILS
              </Link>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      title: "Role",
      key: "email",
      render: (_, columnData) => (
        <>
          {permissions.filter((val) => columnData.permission[val.key]).length >
          0
            ? permissions
                .filter((val) => columnData.permission[val.key])
                .map((value) => (
                  <Tag color="#e5f4fe">
                    <span style={{ color: "#333333" }}>{value.label}</span>
                  </Tag>
                ))
            : "No role(s) assigned"}
        </>
      ),
    },
    {
      title: "Lab Technician",
      key: "lab_technician",
      dataIndex: "lab_technician",
      width: "15%",
      render: (_, columnData) =>
        columnData.status ? (
          <span className="activate">Yes</span>
        ) : (
          <span className="inActivateNotverified">No</span>
        ),
    },
    {
      title: "CREATED",
      key: "status",
      dataIndex: "status",
      className: "date-time",
      render: (_, columnData) => (
        <>
          <p>{moment(columnData.permission.created_at).format("MM/DD/YYYY")}</p>
          <p>{moment(columnData.permission.created_at).format("hh:mm A")}</p>
        </>
      ),
    },
    {
      title: "More",
      key: "actions",
      render: (_, columnData) =>
        columnData.activated ? (
          <ActionsColumn
            columnData={columnData}
            onUpdateUser={onUpdateUser}
            onEditPermissions={onEditPermissions}
            updateLabCompanyStaffProfile={props.updateLabCompanyStaffProfile}
            countryCode={props.countryCode}
            props={props}
          />
        ) : (
          <Button
            className="blue-button"
            onClick={() => toggleActivateModalVisibility(columnData.id)}
          >
            Activate
          </Button>
        ),
    },
  ];

  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const permission = `q[${newValues["q[permission_cont]"]}]`;
    newValues[permission] = true;
    const queryString = Object.keys(newValues)
      .filter((key) => key !== "q[permission_cont]")
      .map((key) => `${key}=${newValues[key]}`)
      .join("&");
    props.getAllLabCompanyStaff(queryString);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption);
  };

  return (
    <div>
      <UserDescriptionModal
        data={currentColumn}
        visible={descriptionModal}
        onCancel={() => setDescriptionModal(false)}
      />
      <Modal
        title="Activate User"
        onCancel={toggleActivateModalVisibility}
        visible={activateModalVisible}
        okButtonProps={{ disabled: otp.length !== 6 }}
        onOk={activateUser}
        className="activate-user-modal"
        okText="Activate"
        destroyOnClose
      >
        <div>
          <span className="otp-input-title">Enter OTP to activate</span>
          <div className="full-width">
            <OtpInput
              isInputNum
              containerStyle={{
                width: "100%",
                fontSize: "25px",
                justifyContent: "space-evenly",
              }}
              inputStyle={styles.otp_input_style}
              value={otp}
              onChange={onOtpChange}
              numInputs={6}
              separator={<span />}
            />
            <Button
              onClick={() =>
                props.resendActivateLabCompanyStuffOTP({ id: selectedColumn })
              }
              type="link"
            >
              {" "}
              Resend OTP
            </Button>
          </div>
        </div>
      </Modal>
      <UserFormModal
        onSubmit={onAddUser}
        onCancel={hideModal}
        visible={modalVisible}
        title="Add Company Staff"
        submitText="Save"
        countryCode={props.countryCode}
      />
      <Row gutter={[0, 16]}>
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            Company Staff
          </Title>
        </Col>
        <Col className="gutter-row" span={6} offset={0}></Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button
            className={`${
              searchOption === true ? "search-open" : "search-close"
            } search-toggle-button`}
            onClick={() => toggleSearch()}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button onClick={showModal} icon={<PlusOutlined />} type="primary">
            <span>ADD STAFF</span>
          </Button>
        </Col>
      </Row>
      {searchOption === true ? (
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Company Staff"
          formItems={[
            {
              key: "q[name_cont]",
              label: "Staff Name",
            },
            {
              key: "q[phone_or_email_cont]",
              label: "Phone / Email",
            },
            {
              key: "q[permission_cont]",
              label: "Select User Role",
              Component: (
                <Select placeholder="User Role" size="large">
                  {permissions.map((val) => (
                    <Option value={`lab_permission_${val.key}_eq`}>
                      {val.label}
                    </Option>
                  ))}
                </Select>
              ),
            },
            {
              key: "q[status_eq]",
              label: "Status",
              Component: (
                <Select placeholder="Status - Active / Blocked" size="large">
                  <Option value>Active</Option>
                  <Option value={false}>Blocked</Option>
                </Select>
              ),
            },
          ]}
        />
      ) : (
        ""
      )}
      <Table
        className="list_table"
        dataSource={props.users}
        columns={columns}
        scroll={{ x: 800 }}
        rowKey="id"
      />
    </div>
  );
}

export default UserManagement;
